import { render, staticRenderFns } from "./sanctionMatched.vue?vue&type=template&id=5c779583&scoped=true"
import script from "./sanctionMatched.vue?vue&type=script&lang=js"
export * from "./sanctionMatched.vue?vue&type=script&lang=js"
import style0 from "./sanctionMatched.vue?vue&type=style&index=0&id=5c779583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c779583",
  null
  
)

export default component.exports